"use strict";

function slider() {
  var el = document.querySelector('.c-slider__products');
  if (!el) {
    return;
  }

  var swiper = new Swiper(el, {
    loop: true,
    autoplay: true,
    effect: 'fade',
    pagination: {
      el: ".c-slider__pagination",
      clickable: true,
      renderBullet: function (index, className) {
        // Fix: Use originalSlides instead of cloned ones
        var realSlides = this.slides.filter(slide => !slide.classList.contains('swiper-slide-duplicate'));
        var slide = realSlides[index];

        // Fallback if something went wrong
        if (!slide) return '<span class="' + className + '">•</span>';

        // Extract data from the real slide
        var link = slide.querySelector('a');
        var url = link ? link.getAttribute('href') : '#';

        var color = slide.dataset.color || '#F1B434';
        var umf = slide.dataset.paginationText || slide.dataset.name || 'Manuka Honey';

        return '<span style="--product-color:' + color + ';" ' +
               'class="c-slider__pagination__bullet ' + className + '" ' +
               'data-url="' + url + '">' + umf + '</span>';
      }
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    }
  });

  // Open product URL in a new tab when bullet is clicked
  var paginationEl = document.querySelector('.c-slider__pagination');
  if (paginationEl) {
    paginationEl.addEventListener('click', function (e) {
      var target = e.target;
      if (target.classList.contains('c-slider__pagination__bullet')) {
        var url = target.getAttribute('data-url');
        if (url && url !== '#') {
          window.location.href = url;
          e.preventDefault();
          e.stopPropagation();
        }
      }
    });
  }

  // Jump to a specific slide if needed
  swiper.slideToLoop(6, 0, false); // 7th real slide, loop-safe
  swiper.autoplay.start();
}

slider();